import { inject, Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { onAuthStateChanged, User } from 'firebase/auth';
import { Store } from '@ngrx/store';

import { AuthActions } from './auth.actions';

@Injectable({ providedIn: 'root' })
export class AuthSessionSyncService {
  private readonly auth = inject(Auth);
  private readonly store = inject(Store);

  private lastUid: string | null = null;

  init(): void {
    this.lastUid = this.auth.currentUser?.uid ?? null;

    onAuthStateChanged(this.auth, (user: User | null) => {
      const uid = user?.uid ?? null;

      if (uid === this.lastUid) return;
      this.lastUid = uid;

      if (uid) {
        this.store.dispatch(AuthActions.loginSucceeded({ uid }));
      } else {
        this.store.dispatch(AuthActions.logoutSucceeded());
      }
    });
  }
}
